export enum CacheStorageEnum {
  companyName = 'company_name',
  cryptoFavorite = 'crypto_favorite',
  recentSearches = 'recent_searches',
  extractHistory = 'extract_history',
  orderHistory = 'order_history',
}
